import { Link } from 'react-router-dom';
import { allVideos } from '@/mocks/videos';

interface VideoCardProps {
  videoId: string;
  size?: 'small' | 'normal' | 'large';
}

export default function VideoCard({ videoId, size = 'normal' }: VideoCardProps) {
  const video = allVideos.find((v) => v.id === videoId);
  if (!video) return null;

  const categoryMap: Record<string, string> = {
    movie: '电影',
    tv: '电视剧',
    variety: '综艺',
    anime: '动漫',
    documentary: '纪录片',
  };

  const imgHeight = {
    small: 'h-40',
    normal: 'h-48',
    large: 'h-64 lg:h-full',
  };

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block"
    >
      <div className={`relative ${imgHeight[size]} rounded-lg overflow-hidden mb-3`}>
        <img
          src={video.imageUrl}
          alt={video.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          title={`${video.title} - ${video.source}在线观看`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-md whitespace-nowrap">
            {video.rating}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 bg-foreground-900/70 text-background-50 text-xs rounded-md whitespace-nowrap">
            {categoryMap[video.category]}
          </span>
        </div>
        <div className="absolute bottom-2 left-2 right-2">
          <div className="flex items-center gap-3 text-xs text-background-50/90">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i> {video.views}
            </span>
            <span>{video.year}</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {video.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
        {video.source} · {video.duration}
      </p>
    </Link>
  );
}